import React from "react";
import DotDropdown from "../DotDropdown";
import {
    Button,
    FormControl,
    RadioGroup,
    FormControlLabel,
    Radio,
    Box,
    Grid,
    Typography,
    Select as MuiSelect,
    MenuItem,
    Checkbox,
    ListItemText
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

export const BreastExaminationTab = ({
    formData,
    setFormData,
    handleSubmit,
    screeningStatus,
    handleOpenUpdateModal,
    setActiveWorkflowTab,
    setOpenConfirmDialog,
    selectedValue,
    setSelectedValue,
    handleResetFindings,
    handletopRadioChange,
    handleRadioChange,
    handleSkinEdemaTypeChange,
    renderDots,
    getSymptomType,
    dotData,
    handleDotClick,
    activeDot,
    dropdownPos,
    setActiveDot,
    axillaryOptions,
    supraclavicularOptions,
    hoveredDot,
    setHoveredDot,
    renderHoverTooltip,
    isDhOrChc
}) => {
    return (
        <>
            <Box sx={{ p: 2.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, borderBottom: '1px solid #eef2f5', bgcolor: '#fafafa', mb: 3 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography sx={{ fontWeight: 800, color: '#1e293b', fontSize: '15px' }}>
                            Status: {screeningStatus}
                        </Typography>
                        {!isDhOrChc && handleOpenUpdateModal && (
                            <Button
                                variant="text"
                                size="small"
                                sx={{ color: '#3f51b5', fontWeight: 700, minWidth: 'auto', p: 0, textTransform: 'none', textDecoration: 'underline' }}
                                onClick={handleOpenUpdateModal}
                            >
                                Update
                            </Button>
                        )}
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Typography sx={{ fontSize: '12px', color: '#3f51b5', fontWeight: 700 }}>
                            📖 Quick Links
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', gap: 2 }}>
                    {/* FOLLOW UP Card */}
                    <Box
                        onClick={() => setActiveWorkflowTab(3)}
                        sx={{
                            width: '95px',
                            height: '75px',
                            border: '1px solid #cbd5e1',
                            borderRadius: '6px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            bgcolor: '#fff',
                            transition: 'all 0.2s',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.03)',
                            '&:hover': { bgcolor: '#9fa8da' }
                        }}
                    >
                        <Typography sx={{ fontSize: '20px', mb: 0.2 }}>📋</Typography>
                        <Typography sx={{ fontSize: '10px', fontWeight: 800, color: '#1e293b' }}>
                            FOLLOW UP
                        </Typography>
                    </Box>

                    {/* REFER Card */}
                    <Box
                        onClick={() => setActiveWorkflowTab(4)}
                        sx={{
                            width: '95px',
                            height: '75px',
                            border: '1px solid #cbd5e1',
                            borderRadius: '6px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            bgcolor: '#fff',
                            transition: 'all 0.2s',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.03)',
                            '&:hover': { bgcolor: '#9fa8da' }
                        }}
                    >
                        <Typography sx={{ fontSize: '20px', mb: 0.2 }}>👥</Typography>
                        <Typography sx={{ fontSize: '10px', fontWeight: 800, color: '#1e293b' }}>
                            REFER
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <form onSubmit={handleSubmit}>
                <div className="row">
                    <Box sx={{ display: 'flex', width: '100%', mb: 3, px: 2, justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <Typography variant="h6" sx={{ fontWeight: 700, color: '#334155', fontSize: '16px' }}>
                                Examination
                            </Typography>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={formData.exam.noAbnormalityFound}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setOpenConfirmDialog(true);
                                            } else {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    exam: {
                                                        ...prev.exam,
                                                        noAbnormalityFound: false
                                                    }
                                                }));
                                            }
                                        }}
                                        sx={{ color: '#cbd5e1', '&.Mui-checked': { color: '#3f51b5' } }}
                                    />
                                }
                                label={<Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#475569' }}>No Abnormality Detected</Typography>}
                            />
                        </Box>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                format="DD/MM/YYYY"
                                label="Assessment Date"
                                value={formData.assessmentDate ? (dayjs(formData.assessmentDate, 'YYYY-MM-DD').isValid() ? dayjs(formData.assessmentDate, 'YYYY-MM-DD') : dayjs(formData.assessmentDate, 'DD-MM-YYYY')) : null}
                                onChange={(newValue) => setFormData(prev => ({
                                    ...prev,
                                    assessmentDate: newValue ? newValue.format('YYYY-MM-DD') : ''
                                }))}
                                maxDate={dayjs()}
                                slotProps={{
                                    textField: {
                                        size: 'small',
                                        sx: { width: '220px', '& .MuiOutlinedInput-root': { borderRadius: '10px' } }
                                    }
                                }}
                            />
                        </LocalizationProvider>
                    </Box>

                    {[
                        { id: "Lump", label: "LUMP", img: "/images/breast_lump.png" },
                        { id: "Ulcer", label: "Ulcer", img: "/images/breast_ulcer.png" },
                        { id: "Retraction of Nipple", label: "RETRACTION OF NIPPLE", img: "/images/breast_erosion.png" },
                        { id: "Nipple Discharge", label: "NIPPLE DISCHARGE", img: "/images/breast_discharge.png" },
                        { id: "Skin Dimpling Puckering", label: "SKIN DIMPLING / PUCKERING", img: "/images/breast_erosion.png" },
                        { id: "Retraction of Skin", label: "RETRACTION OF SKIN", img: "/images/breast_erosion.png" },
                    ].map(({ id, label, img }) => {
                        const isSelected = selectedValue === id;
                        return (
                            <Box key={id} className="col-md-4 col-xs-6 col-6" sx={{ mb: 2 }}>
                                <FormControlLabel
                                    className={`oralRadio d-flex align-items-center justify-content-center luco-lable-text mb-1 ${isSelected ? 'selected' : ''}`}
                                    sx={{
                                        border: isSelected ? '2px solid #5c6bc0' : '1px solid #cfd8dc',
                                        backgroundColor: isSelected ? '#9fa8da' : '#ffffff',
                                        color: isSelected ? '#1c2d5a' : '#2c3e50',
                                        borderRadius: '6px',
                                        m: 0,
                                        p: '8px 12px',
                                        width: '100%',
                                        cursor: formData.exam.noAbnormalityFound ? 'not-allowed' : 'pointer',
                                        pointerEvents: formData.exam.noAbnormalityFound ? 'none' : 'auto',
                                        opacity: formData.exam.noAbnormalityFound ? 0.6 : 1,
                                        transition: 'all 0.2s ease-in-out',
                                        '&:hover': {
                                            border: isSelected ? '2px solid #5c6bc0' : '1px solid #5c6bc0',
                                            backgroundColor: isSelected ? '#9fa8da' : '#f5f7fa',
                                        },
                                        '& .MuiTypography-root': {
                                            fontWeight: 700,
                                            width: '100%',
                                            display: 'flex',
                                            alignItems: 'center'
                                        }
                                    }}
                                    control={
                                        <Radio
                                            name="breastScreeningRadio"
                                            id={id}
                                            onChange={handletopRadioChange}
                                            checked={isSelected}
                                            disabled={formData.exam.noAbnormalityFound}
                                            sx={{ display: 'none' }}
                                        />
                                    }
                                    label={
                                        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                            <Box
                                                sx={{
                                                    width: 36,
                                                    height: 36,
                                                    borderRadius: '50%',
                                                    backgroundColor: '#cfd8dc',
                                                    border: '2px solid #ffffff',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    marginRight: '12px',
                                                    flexShrink: 0,
                                                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                                }}
                                            >
                                                <img
                                                    src={img}
                                                    alt=""
                                                    style={{
                                                        width: 20,
                                                        height: 20,
                                                        objectFit: 'contain'
                                                    }}
                                                />
                                            </Box>
                                            <span style={{ fontSize: '13px', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.5px' }}>{label}</span>
                                        </Box>
                                    }
                                />
                            </Box>
                        );
                    })}
                </div>

                <div className="demoTaskSection">
                    <div className="breastBoxSection">
                        <div className="mouthOralLocHeader">
                            <h6>Showing earlier findings</h6>
                            <div className="rightFinding">
                                <div className="ShowAllFindings" onClick={() => setSelectedValue && setSelectedValue("")} style={{ cursor: 'pointer' }}>
                                    Show All Findings
                                </div>
                                <div className="reset" onClick={handleResetFindings} style={{ cursor: 'pointer' }}>
                                    Reset
                                </div>
                            </div>
                        </div>
                        <h5>Mark Location for : {selectedValue || "All Findings"}</h5>
                        <div className="breastCanserCheck" style={{ 
                            pointerEvents: formData.exam.noAbnormalityFound ? 'none' : 'auto', 
                            opacity: formData.exam.noAbnormalityFound ? 0.6 : 1 
                        }}>
                            <div className="leftBreast">
                                <h5>Right</h5>
                                <div className="wrapper">
                                    <div className="ellipse" />
                                    <div className="line vertical" />
                                    <div className="line horizontal" />
                                    {renderDots("left")}
                                    <div
                                        className={`dot center-dot ${dotData["left-center"] && (!selectedValue || dotData["left-center"].type === getSymptomType(selectedValue)) ? "selected" : ""}`}
                                        onMouseEnter={() => setHoveredDot && setHoveredDot("left-center")}
                                        onMouseLeave={() => setHoveredDot && setHoveredDot(null)}
                                        onClick={(e) => handleDotClick("left-center", e)}
                                    >
                                        {hoveredDot === "left-center" && dotData["left-center"] && renderHoverTooltip && renderHoverTooltip("left-center", dotData["left-center"])}
                                    </div>
                                </div>
                            </div>
                            <div className="rightBreast">
                                <h5>Left</h5>
                                <div className="wrapper">
                                    <div className="ellipse" />
                                    <div className="line vertical" />
                                    <div className="line horizontal" />
                                    {renderDots("right")}
                                    <div
                                        className={`dot center-dot ${dotData["right-center"] && (!selectedValue || dotData["right-center"].type === getSymptomType(selectedValue)) ? "selected" : ""}`}
                                        onMouseEnter={() => setHoveredDot && setHoveredDot("right-center")}
                                        onMouseLeave={() => setHoveredDot && setHoveredDot(null)}
                                        onClick={(e) => handleDotClick("right-center", e)}
                                    >
                                        {hoveredDot === "right-center" && dotData["right-center"] && renderHoverTooltip && renderHoverTooltip("right-center", dotData["right-center"])}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {activeDot && <DotDropdown dotId={activeDot} position={dropdownPos} selectedValue={selectedValue} onClose={() => setActiveDot(null)} dotData={dotData[activeDot]} />}

                    </div>

                    <div className="breastFormSection" style={{ padding: '20px', width: '100%', pointerEvents: formData.exam.noAbnormalityFound ? 'none' : 'auto', opacity: formData.exam.noAbnormalityFound ? 0.6 : 1 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <FormControl component="fieldset" disabled={formData.exam.noAbnormalityFound}>
                                    <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5, color: '#5f6368' }}>Change in shape / size of the breast:</Typography>
                                    <RadioGroup
                                        row
                                        name="shapeSizeChangeInBreast"
                                        value={formData.exam.shapeSizeChangeInBreast === true ? "true" : formData.exam.shapeSizeChangeInBreast === false ? "false" : ""}
                                        onChange={handleRadioChange}
                                    >
                                        <FormControlLabel value="true" control={<Radio size="small" />} label="Yes" />
                                        <FormControlLabel value="false" control={<Radio size="small" />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl component="fieldset" disabled={formData.exam.noAbnormalityFound}>
                                    <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5, color: '#5f6368' }}>Both nipples not at same level:</Typography>
                                    <RadioGroup
                                        row
                                        name="nippleLevelNotSame"
                                        value={formData.exam.nippleLevelNotSame === true ? "true" : formData.exam.nippleLevelNotSame === false ? "false" : ""}
                                        onChange={handleRadioChange}
                                    >
                                        <FormControlLabel value="true" control={<Radio size="small" />} label="Yes" />
                                        <FormControlLabel value="false" control={<Radio size="small" />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl component="fieldset" disabled={formData.exam.noAbnormalityFound}>
                                    <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5, color: '#5f6368' }}>Skin Edema:</Typography>
                                    <RadioGroup
                                        row
                                        name="skinEdema"
                                        value={formData.exam.skinEdema === true ? "true" : formData.exam.skinEdema === false ? "false" : ""}
                                        onChange={handleRadioChange}
                                    >
                                        <FormControlLabel value="true" control={<Radio size="small" />} label="Yes" />
                                        <FormControlLabel value="false" control={<Radio size="small" />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl component="fieldset" disabled={formData.exam.noAbnormalityFound || !formData.exam.skinEdema}>
                                    <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5, color: '#5f6368' }}>Skin Edema Type:</Typography>
                                    <RadioGroup
                                        row
                                        name="isLessSkinEdma"
                                        value={formData.exam.isLessSkinEdma === true ? "less" : formData.exam.isMoreSkinEdma === true ? "more" : ""}
                                        onChange={handleSkinEdemaTypeChange}
                                    >
                                        <FormControlLabel value="less" control={<Radio size="small" />} label="Less than 1/3rd of area of breast" />
                                        <FormControlLabel value="more" control={<Radio size="small" />} label="More than 1/3rd of area of breast" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <FormControl component="fieldset" disabled={formData.exam.noAbnormalityFound}>
                                    <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5, color: '#5f6368' }}>Lymphadenopathy:</Typography>
                                    <RadioGroup
                                        row
                                        name="lymphadenopathy"
                                        value={formData.exam.lymphadenopathy === true ? "true" : formData.exam.lymphadenopathy === false ? "false" : ""}
                                        onChange={handleRadioChange}
                                    >
                                        <FormControlLabel value="true" control={<Radio size="small" />} label="Yes" />
                                        <FormControlLabel value="false" control={<Radio size="small" />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <FormControl component="fieldset" disabled={formData.exam.noAbnormalityFound}>
                                    <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5, color: '#5f6368' }}>Axillary:</Typography>
                                    <RadioGroup
                                        row
                                        name="axillary"
                                        value={formData.exam.axillary === true ? "true" : formData.exam.axillary === false ? "false" : ""}
                                        onChange={handleRadioChange}
                                    >
                                        <FormControlLabel value="true" control={<Radio size="small" />} label="Yes" />
                                        <FormControlLabel value="false" control={<Radio size="small" />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <FormControl component="fieldset" disabled={formData.exam.noAbnormalityFound}>
                                    <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5, color: '#5f6368' }}>Supraclavicular:</Typography>
                                    <RadioGroup
                                        row
                                        name="supraclavicular"
                                        value={formData.exam.supraclavicular === true ? "true" : formData.exam.supraclavicular === false ? "false" : ""}
                                        onChange={handleRadioChange}
                                    >
                                        <FormControlLabel value="true" control={<Radio size="small" />} label="Yes" />
                                        <FormControlLabel value="false" control={<Radio size="small" />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <FormControl component="fieldset" disabled={formData.exam.noAbnormalityFound}>
                                    <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5, color: '#5f6368' }}>Infraclavicular:</Typography>
                                    <RadioGroup
                                        row
                                        name="infraclavicular"
                                        value={formData.exam.infraclavicular === true ? "true" : formData.exam.infraclavicular === false ? "false" : ""}
                                        onChange={handleRadioChange}
                                    >
                                        <FormControlLabel value="true" control={<Radio size="small" />} label="Yes" />
                                        <FormControlLabel value="false" control={<Radio size="small" />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Typography variant="body2" sx={{ fontWeight: 600, mb: 1, color: '#5f6368' }}>Axillary Node Details</Typography>
                                <FormControl fullWidth variant="standard" disabled={formData.exam.noAbnormalityFound}>
                                    <MuiSelect
                                        multiple
                                        value={formData.exam.nodeAxillary ? formData.exam.nodeAxillary.split(',').filter(Boolean) : []}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            let selectedValues = typeof val === 'string' ? val.split(',') : val;
                                            if (selectedValues.includes('Select All')) {
                                                if (selectedValues.length === axillaryOptions.length) {
                                                    selectedValues = [];
                                                } else {
                                                    selectedValues = axillaryOptions.map(opt => opt.value).filter(v => v !== 'Select All');
                                                }
                                            }
                                            setFormData(prev => ({
                                                ...prev,
                                                exam: {
                                                    ...prev.exam,
                                                    nodeAxillary: selectedValues.join(',')
                                                }
                                            }));
                                        }}
                                        renderValue={(selected) => selected.join(', ')}
                                    >
                                        {axillaryOptions.map((opt) => (
                                            <MenuItem key={opt.value} value={opt.value}>
                                                <Checkbox checked={formData.exam.nodeAxillary ? formData.exam.nodeAxillary.split(',').includes(opt.value) : false} />
                                                <ListItemText primary={opt.label} />
                                            </MenuItem>
                                        ))}
                                    </MuiSelect>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Typography variant="body2" sx={{ fontWeight: 600, mb: 1, color: '#5f6368' }}>Supraclavicular Node Details</Typography>
                                <FormControl fullWidth variant="standard" disabled={formData.exam.noAbnormalityFound}>
                                    <MuiSelect
                                        multiple
                                        value={formData.exam.nodeSupraclavicular ? formData.exam.nodeSupraclavicular.split(',').filter(Boolean) : []}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            let selectedValues = typeof val === 'string' ? val.split(',') : val;
                                            if (selectedValues.includes('All')) {
                                                if (selectedValues.length === supraclavicularOptions.length) {
                                                    selectedValues = [];
                                                } else {
                                                    selectedValues = supraclavicularOptions.map(opt => opt.value).filter(v => v !== 'All');
                                                }
                                            }
                                            setFormData(prev => ({
                                                ...prev,
                                                exam: {
                                                    ...prev.exam,
                                                    nodeSupraclavicular: selectedValues.join(',')
                                                }
                                            }));
                                        }}
                                        renderValue={(selected) => selected.join(', ')}
                                    >
                                        {supraclavicularOptions.map((opt) => (
                                            <MenuItem key={opt.value} value={opt.value}>
                                                <Checkbox checked={formData.exam.nodeSupraclavicular ? formData.exam.nodeSupraclavicular.split(',').includes(opt.value) : false} />
                                                <ListItemText primary={opt.label} />
                                            </MenuItem>
                                        ))}
                                    </MuiSelect>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </div>

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%', mt: 4, pr: 2 }}>
                        <Button
                            type="submit"
                            variant="contained"
                            sx={{
                                bgcolor: '#3f51b5',
                                color: '#fff',
                                fontWeight: 700,
                                textTransform: 'none',
                                px: 4.5,
                                py: 1,
                                borderRadius: '4px',
                                '&:hover': { bgcolor: '#303f9f' }
                            }}
                        >
                            Save & Continue
                        </Button>
                    </Box>
                </div>
            </form>
        </>
    );
};
